<template>
  <!-- 练习中心考试练习模式 -->
  <div class="uni-startPractice">
    <div class="leftBox">
      <Title text="我的笔记">
        <i
          slot="right"
          class="iconfont iconfanhui icon-back"
          @click="$router.push({ name: 'myNotes' })"
        ></i>
      </Title>

      <ul>
        <li class="mat10" v-for="(item, index) in datas" :key="index">
          <div>
            <el-collapse v-model="activeNames">
              <el-collapse-item
                class="question-collapse-item"
                :name="item.question_id"
              >
                <template slot="title">
                  <span class="primary mar10" style="align-self: flex-start"
                    >[{{ item.question_title }}]</span
                  >
                  <span style="flex: 1">{{
                    textLength(item.question_title, item.id)
                  }}</span>
                  <!--                  <span class="gray-light mal10 mar10"-->
                  <!--                    >（来自-->
                  <!--                    <span v-if="item.source === 'shi_juan'">试卷练习</span>-->
                  <!--                    <span v-if="item.source === 'lian_xi'">章节练习</span>-->
                  <!--                    <span v-if="item.source === 'zuo_ye'">做作业</span>-->
                  <!--                    <span v-if="item.source === 'zhi_neng_lian_xi'"-->
                  <!--                      >智能练习</span-->
                  <!--                    >-->
                  <!--                    ）-->
                  <!--                  </span>-->
                </template>
                <!-- 填空题 -->
                <FillBlank
                  v-if="item.question_style === 4"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 单选题 -->
                <ChoiceOne
                  v-if="item.question_style === 1"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 多选题 -->
                <ChoiceMultiple
                  v-if="item.question_style === 3"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 判断题 -->
                <Judge
                  v-if="item.question_style === 2"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!-- 简答题 -->
                <Subjective
                  v-if="item.question_style === 5"
                  :datas="item"
                  :isDisabled="isDisabled"
                />
                <!--                <div class="submit mat20">-->
                <!--                  <div @click="delNote(item.id)">删除笔记</div>-->
                <!--                </div>-->
                <!-- 解析 -->
                <QuestionAnalysis
                  @delNote="delNote"
                  :showNotes="true"
                  :analysisDatas="item"
                />
              </el-collapse-item>
            </el-collapse>
          </div>
        </li>
      </ul>
      <ComponentEmpty v-if="datas.length == 0" title="暂无笔记" tips="" />
    </div>

    <!-- 提示框 -->
    <ComponentDialog1
      icon="fail"
      title="确定删除该笔记"
      :visible.sync="isDelconform"
      iconPosition="left-top"
      @confirm="delConfirm"
      @cancel="isDelconform = !isDelconform"
      :showCancelBtn="true"
      cancelText="取消"
      confirmText="确定"
    ></ComponentDialog1>
  </div>
</template>

<script>
import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";
import QuestionAnalysis from "./questionAnalysis";
import { studyRecordInfo, qnoteDel } from "@/api/record";

export default {
  name: "uni-startPractice",
  components: {
    QuestionAnalysis, //解析
    ChoiceOne, //单选
    FillBlank, //填空
    Judge, //判断
    ChoiceMultiple, //多选
    Subjective, //简答
  },
  watch: {},
  data() {
    return {
      majorUuid: "",
      courseUuid: "",
      activeNames: [],
      isDisabled: true,
      isDelconform: false,
      delTopicId: "",
      // 题目集合
      datas: [],
      topicType: "",
    };
  },
  // 挂载结束状态
  created() {
    this.majorUuid = this.$store.state.common.studentMajorUuid;
    this.courseUuid = this.$route.query.courseUuid;
    this.topicType = this.$route.query.topicType;
    this.getAnalysisDetail();
  },
  methods: {
    textLength(val, id) {
      if (this.activeNames.includes(id)) {
        return val;
      } else {
        if (val.length > 100) return val.substr(0, 100) + "...";
        return val;
      }
    },
    /**
     * 练习题请求
     */
    async getAnalysisDetail() {
      const params = {
        question_style: this.topicType,
        course_id: this.courseUuid,
      };
      const res = await studyRecordInfo(params);
      if (res.code === 200) {
        this.datas = res.result.list || [];
        console.log(this.datas);
      }
    },
    /**
     * 删除笔记
     */
    delNote(topicId) {
      console.log(topicId);
      this.isDelconform = true;
      this.delTopicId = topicId;
    },
    async delConfirm() {
      const params = {
        id: this.delTopicId,
      };
      const res = await qnoteDel(params);
      if (res) {
        await this.getAnalysisDetail();
        this.isDelconform = false;
        this.$message({
          message: "删除笔记成功",
          type: "success",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
</style>
<style lang="scss" scoped>
.uni-startPractice {
  display: flex;
  padding: 20px;
  padding-bottom: 0px;

  /deep/ .question-collapse-item {
    .el-collapse-item__header {
      background-color: #f8f8f8;
      padding: 20px;
      height: auto;
      line-height: normal;
    }
  }
  .leftBox {
    background-color: #ffffff;
    flex: 1 1 auto;
    padding: 20px 40px;
    margin-bottom: 0;
    min-height: $contentH;

    .icon-back {
      font-size: 34px;
      color: #a8a8a8;
      cursor: pointer;

      &:hover {
        color: #333;
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
</style>
